app.mediator.registerModule(MODULE_NAME__PROFILE_FORM, function (app) {

    var dataStore = app.data;
    var helpers = app.helpers.funcs;

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The profile picture upload file input
        $fileInputElem: null,

        // The certificate document upload file input
        $certificateFileInputElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            var scope = this;

            var baseConstraints = dataStore.get('validation.profileForm');
            this.$formElem = $('#form-profile');
            if (!this.$formElem.length) return;
         
            // Create jda validator instance
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(baseConstraints);

            this.$formElem.submit(function (e, options) {
                options = options || {};
                if (!options.formChecked) {
                    e.preventDefault();

                    var documentIds = [];
                    $("div.preview").each(function() {
                        var documentId = $(this).data("image-id");
                        if (documentId) {
                            documentIds.push(documentId);
                        }
                    });

                    helpers.validateDocuments(
                        documentIds,
                        function() {
                            scope.doSave(e);
                        },
                        EVENT_NAME__PROFILE_FORM__IMAGE_DOESNT_EXIST,
                        window.serverData.generalLanguageStrings.imageOrCertificateNeedsReUploadingToastMessage);
                }
            });

            this.$formElem.find('input[type=password], input[type=text], textarea').keyup(function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;

                // Adjust this element's validation messages
                var $elem = $(this);
                var formFieldId = scope.jdaValidator.configuration.getFormFieldId($elem);
                var messageBag = scope.jdaValidator.getMessageBagForFormField(formFieldId);
                scope.jdaValidator.presenter.clearStatus($elem);
                scope.jdaValidator.presenter.showStatus($elem, messageBag);
            });

            this.$formElem.find('input[type=file]').on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function () {
                var $elem = $(this);
                scope.handleElemChange($elem);
            });

            // Init upload
            scope.initUploadInput();
            scope.initCertificateUploadInput();
            scope.initFileUploadButtonAccessibility();
            app.mediator.notify(EVENT_NAME__PROFILE_FORM__INITIATED);
        },

        doSave: function (e) {
            var scope = this;
            var messageBag = scope.jdaValidator.getMessageBag();
            scope.jdaValidator.presenter.clearStatuses();
            scope.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                scope.jdaValidator.presenter.scrollToFirstError();
            } else {
                var $btn = scope.$formElem.find('#saveProfileButton');
                app.helpers.funcs.loadifyButtons($btn, true);
                $(e.currentTarget).trigger('submit', { 'formChecked': true });
            }
        },

        initUploadInput: function () {
            var scope = this;
            this.$fileInputElem = this.$formElem.find('.fp-profile-photo .jda-file-input-seed');
            var $inputAndDropWrapElem = $('.fp-profile-photo .feedback-group');
            var $dropAreaElem = $inputAndDropWrapElem.find('.file-drop-area');
            if (this.$fileInputElem.length) {

                this.$fileInputElem.jdaUpload({
                    $dropAreaElem: $dropAreaElem,
                    uploadTargetUrl: helpers.url('/umbraco/api/DocumentApi/UploadProfileImage'),
                    removeButtonText: this.$fileInputElem.data('removebuttontext'),
                    alwaysUseClientSideThumb: true
                });

                this.$fileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILE_REMOVED, function () {
                    scope.doFileValidation(false);
                });
                this.$fileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function (e, data) {
                    scope.doFileValidation(data.files);
                });
                this.$fileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILE_TOO_LARGE, function (e, data) {
                    scope.doFileValidation(data.files);
                });

            } else {
                var $previews = $dropAreaElem.find('.preview');
                if ($previews.length > 0) {
                    $dropAreaElem.find('.drop-placeholder-msg').hide();
                    $dropAreaElem.addClass("has-files");
                }
            }
        },

        initCertificateUploadInput: function () {
            var scope = this;
            this.$certificateFileInputElem = this.$formElem.find('.fp-eligibility .jda-file-input-seed');
            var $inputAndDropWrapElem = this.$certificateFileInputElem.closest('.feedback-group');
            var $dropAreaElem = $inputAndDropWrapElem.find('.file-drop-area');
            this.$certificateFileInputElem.jdaUpload({
                $dropAreaElem: $dropAreaElem,
                uploadTargetUrl: helpers.url('/umbraco/api/DocumentApi/UploadRegistrationCertificate'),
                removeButtonText: this.$certificateFileInputElem.data('removebuttontext'),
                alwaysUseClientSideThumb: true
            });

            this.$certificateFileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILE_REMOVED, function () {
                scope.doFileValidation(false);
                $("#certificate-filename").text('');
            });
            this.$certificateFileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function (e, data) {
                scope.doFileValidation(data.files);
                $("#certificate-filename").text(data.files[0].name);
            });
            this.$certificateFileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILE_TOO_LARGE, function (e, data) {
                scope.doFileValidation(data.files);
            });
        },

        initFileUploadButtonAccessibility: function () {
            $(document).on('keydown', '#selectCertificateFileButton, #selectFileButton', function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                    e.preventDefault();
                    var targetInputId = $(this).attr('for');
                    if (targetInputId) {
                        $('#' + targetInputId).trigger('click');
                    }
                }
            });
        },

        doFileValidation: function (files) {

            var fileInputElems = [
                this.$fileInputElem,
                this.$certificateFileInputElem
            ];
            var scope = this;
            fileInputElems.forEach(function ($fileInput) {
                var formFieldId = scope.jdaValidator.configuration.getFormFieldId($fileInput);
                if (typeof files !== 'undefined') {
                    if (files === false) {
                        scope.jdaValidator.clearCachedValuesForFormField(formFieldId);
                    } else {
                        scope.jdaValidator.cacheValuesForFormField(formFieldId, files);
                    }
                }
                var messageBag = scope.jdaValidator.getMessageBagForFormField(formFieldId);
                scope.jdaValidator.presenter.clearStatus($fileInput);
                scope.jdaValidator.presenter.showStatus($fileInput, messageBag);
            });
        },

        // NB We should not run validation checks on the fields that are validated via data obtained via AJAX.
        // (If we do, we may breifly get a 'Looks good' message which then quickly changes to 'Looks bad', which 
        // doesn't make for the best user experience.
        // When the AJAX validation does run, it will call this method with a second param of true, which indicates
        // that it is actually ok to run the validation checks, as all data is now immediately available.
        handleElemChange: function ($elem, forceValidationProcess) {
            forceValidationProcess = typeof forceValidationProcess !== 'null' ? forceValidationProcess : false;
            var elemId = this.jdaValidator.configuration.getFormFieldId($elem);
            if (elemId == 'emailAddressInput' && (!forceValidationProcess)) {
                return;
            }
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        }
    };
});